<!--
User booking display
@author cm359n
-->
<template>
  <div id="contain" class="container"><div v-if="userBookings" class='booking'>
  <p v-if="userBookings && userBookings.length > 0" class='heading'>Bookings</p>
    <RoomDisplay v-for="ub in userBookings"
      :changeCallback="getUserBookings"
      :bookingId="ub[0]"
      :key="ub[0]"
      :bookingStatus="ub[15]"
      :room="ub[1]"
      :date="objectForDate(dateFromEpochMs(ub[3])).display"
      :startTime="ub[4]"
      :endTime="ub[5]"
      :attendees="ub[13]"
      :capacity="ub[18]"
      :showNoFoodDrink="true"
     />
   </div>
   <br/><br/>
     </div>
</template>

<script setup>
  import {ref, onMounted} from 'vue'
  import axios from 'axios'

  //Composables
  import {useStringUtil} from '@/composables/StringMethods.js'
  const {objectForDate, dateFromEpochMs} = useStringUtil()

  //Components
  import RoomDisplay from '@/components/booking/RoomDisplay.vue'

  const userBookings = ref([])

  onMounted(
    () => {
      getUserBookings()
    }
  )

  function getUserBookings () {
    axios.get('/timetable/bookingv2/bookings')
      .then(response => {
        let bookings = []
        let minDte = new Date()
        minDte.setTime(minDte.getTime() - 86400 * 1000)
        if (Array.isArray(response.data)) {
          // only render bookings for the future + up to 24 hours in the past
          response.data.forEach((bk) => {
            let bookingEpochSeconds = objectForDate(dateFromEpochMs(bk[3])).value
            if (bookingEpochSeconds > minDte.getTime()) {
              bookings.push(bk)
            }
          })
        }
        userBookings.value = bookings
      }).catch(error => {
        console.log('ERROR')
        console.log(error)
      })
  }
</script>

<style>

div.booking {
    margin-top:30px;
}

.heading {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: var(--uog-dark-blue);
}

</style>
